export const events = {
  USER_SIGNED_IN: 'auth/userSignedIn',
  USER_SIGNED_OUT: 'auth/userSignedOut',
  USER_LOADED: 'auth/userLoaded'
};